/**
 * JS for ACF: Flexible Content > Layouts > Slider vertical de blocs
 */

const sliderBlocks = () => {
  const parent = document.querySelectorAll(".slider-blocks");
  let currentChild = 0;

  if (parent.length > 0) {
    parent.forEach((el) => {
      if (el.classList.contains("slider-blocks--disabled")) {
        return;
      }

      const upArrow = document.querySelector(".slider-blocks__arrow--prev");
      const downArrow = document.querySelector(".slider-blocks__arrow--next");
      const toggleButton = document.querySelector(
        ".slider-blocks__arrow--next"
      );

      const simpleBar = new SimpleBar(el, {
        autoHide: false,
        scrollbarMaxSize: 55,
      });

      upArrow.addEventListener("click", () => {
        simpleBar.getScrollElement().scrollTop -= 300;
      });

      downArrow.addEventListener("click", () => {
        simpleBar.getScrollElement().scrollTop += 300;
      });
    });

    const toggleBtns = document.querySelectorAll(".slider-blocks__toggle");

    if (toggleBtns.length > 0) {
      toggleBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
          const slidingContent = btn.nextElementSibling;
          if (slidingContent.classList.contains("is-visible")) {
            slidingContent.classList.remove("is-visible");
            slidingContent.classList.add("is-hidden");
          } else {
            slidingContent.classList.remove("is-hidden");
            slidingContent.classList.add("is-visible");
          }
        });
      });
    }
  }
};

sliderBlocks();
